'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Drag = function Drag(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 6 22' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'drag'
      ),
      _react2.default.createElement('path', { d: 'M4 20h2v2H4v-2zm0-5h2v2H4v-2zm0-5h2v2H4v-2zm0-5h2v2H4V5zm0-5h2v2H4V0zM0 20h2v2H0v-2zm0-5h2v2H0v-2zm0-5h2v2H0v-2zm0-5h2v2H0V5zm0-5h2v2H0V0z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = Drag;
//# sourceMappingURL=Drag.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Drag.js